import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-student-grievance',
    templateUrl: './student-grievance.component.html',
    styleUrls: ['./student-grievance.component.scss']
})
export class StudentGrievanceComponent implements OnInit, OnDestroy {
    src: string = '/assets/pdf/Student Grievance Redressal Cell.pdf';
    title: string = 'Student Grievance Redressal Cell';

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
